<template>
  <div class="flex flex-col xl:w-[1000px] my-6 gap-1">
    <slot />
  </div>
</template>
